import { render, staticRenderFns } from "./Comingsoon.vue?vue&type=template&id=fc5f5d12&scoped=true&"
import script from "./Comingsoon.vue?vue&type=script&lang=js&"
export * from "./Comingsoon.vue?vue&type=script&lang=js&"
import style0 from "./Comingsoon.vue?vue&type=style&index=0&id=fc5f5d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5f5d12",
  null
  
)

export default component.exports